<template>
    <div class="wrapper">
        <!--<div class="header">-->
            <!--<span>商品</span>-->
            <!--<span>单价</span>-->
            <!--<span>数量</span>-->
            <!--<span>实付金额</span>-->
            <!--<span>订单状态</span>-->
            <!--&lt;!&ndash;<span >利润</span>&ndash;&gt;-->
            <!--<span>操作</span>-->
        <!--</div>-->
        <div v-if="orderList.length === 0" style="text-align: center">暂无数据</div>
        <div v-else>
            <!--<Order v-for="item in orderList" :key="item.id" :order="item" :getOrderList="getOrderList" :temp="temp" :isDetail="isDetail"></Order>-->
            <list-order
                :getOrderList="getOrderList"
                :orderList="orderList"
            >
            </list-order>
            <!--<el-pagination-->
                <!--background-->
                <!--layout="prev, pager, next"-->
                <!--:current-page="currPage"-->
                <!--:page-count="totalPage"-->
                <!--:getOrderList="getOrderList"-->
                <!--@current-change="handlePageChange"-->
            <!--&gt;-->
            <!--</el-pagination>-->
        </div>
    </div>
</template>

<script>
    import Order from './Order';
    import OrderList from './OrderList'
    import Vue from 'vue';
    // import OrderList from "../OrderControl/OrderList";

    Vue.component('Order', Order);
    Vue.component('ListOrder', OrderList);
    export default {
        components: {OrderList},
        props: ['orderList', 'totalPage', 'getOrderList', 'currPage', 'temp', 'isDetail'],
        data () {
            return {};
        },
        activated() {
          this.getOrderList()
        },
        methods: {
            handlePageChange(val) {
                this.getOrderList({page: val});
            }
        },
    };
</script>

<style lang="less" scoped>
    .wrapper {
        .header {
            height: 40px;
            margin-bottom: 15px;
            background: #f2f4f5;
            line-height: 40px;
            font-size: 14px;
            color: #636975;
            &>span{
                display: inline-block;
                text-align: center;
            }
            &>span:nth-child(1) {
                width:21%;
            }
            &>span:nth-child(2) {
                width: 5%;
            }
            &>span:nth-child(3) {
                width: 3%;
            }
            &>span:nth-child(4) {
                width: 38%;
            }
            &>span:nth-child(5) {
                width: 6.5%;
            }
            &>span:nth-child(6) {
                width: 25%;
            }
            &>span:nth-child(7) {
                width:7%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/Content.vue